// @ts-expect-error Untyped module
import { catchAndRethrowNetworkError } from 'crm_data/bCommerce/monitoring/errorUtils';
import { paymentsClient } from './clients';
export const fetchTransactionLimits = ({
  portalId,
  currency
}) => {
  return paymentsClient.get(`payments-checkout/v1/checkout-sessions/by-portal/${portalId}/limits?currency=${currency}`).catch(catchAndRethrowNetworkError);
};